<template>
  <div class="page_Modle">
    <el-pagination
      :current-page.sync="page"
      :page-sizes="pageSizes"
      :page-size.sync="pageSizeLength"
      layout="total, sizes, prev, pager, next, jumper"
      @current-change="currentChange"
      @size-change="sizeChange"
      :total="pageTotal">
    </el-pagination>
  </div>
</template>
<script>
export default {
  props: {
    currentPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    },
    pageSizes: {
      type: Array,
      default: function() {
        return [10, 20, 30, 40, 50];
      }
    },
    total: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      page: 1,
      pageSizeLength: 10,
      pageTotal: 10
    };
  },
  created() {
    this.page = this.currentPage;
    this.pageSizeLength = this.pageSize;
    this.pageTotal = this.total
  },
  methods: {
    currentChange(val) {
      this.$emit('currentChange', val);
    },
    sizeChange(val) {
      this.$emit('sizeChange', val);
    }
  },
  watch: {
    'currentPage': function (newVal, oldVal) {
      this.page = newVal;
    },
    'pageSize': function (newVal, oldVal) {
      this.pageSizeLength = newVal;
    },
    'total': function (newVal, oldVal) {
      this.pageTotal = newVal
    }
  }
};
</script>
<style lang="scss">
  .page_Modle{
    margin: 15px;
    text-align: center;
  }
</style>
